const features = [
  {
    icon: 'ri-flashlight-line',
    title: '影视更新快',
    desc: '全网最新电视剧更新同步追踪，首播、续订、停播动态一目了然，追剧不等待。',
  },
  {
    icon: 'ri-movie-2-line',
    title: '新剧抢先看',
    desc: '新剧上线第一时间收录，定档预告、开播提醒、分集更新，让你永远快人一步。',
  },
  {
    icon: 'ri-tv-2-line',
    title: '最新综艺在线',
    desc: '热门综艺同步更新，从选秀到真人秀，从脱口秀到纪录片，高清在线不缓冲。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '高清不卡',
    desc: '全站高清片源，智能适配网速，手机平板电脑多端畅看，真正的高清流畅体验。',
  },
  {
    icon: 'ri-heart-pulse-line',
    title: '追剧党首选',
    desc: '数十万追剧党的共同选择，热门榜单、口碑推荐、个性化片单，让追剧更高效。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
            追剧为什么选久久
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            五大核心优势，重新定义追剧体验
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {features.map((item, idx) => (
            <div
              key={idx}
              className="group p-5 md:p-6 rounded-lg bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-300 text-center"
            >
              <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2">
                {item.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}